module.exports = __webpack_public_path__ + "static/media/home-comp-logos-jrcigars.db9655b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-comp-logos-jrcigars.png
// module id = 270
// module chunks = 0